import { Injectable } from '@angular/core';

import { LambdaService } from './lambda.service'
import { SendInviteDto, ResendInviteDto, InviteStatusDto } from '../models/models';
import { InviteStatusResponse, SendInviteResponse, ServerlessResponse } from '../models/response';
import { AlertService } from './alert.service'

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private _lambdaService: LambdaService,
    private _alertService: AlertService
  ) {}

  async sendInvite(requestPayload: SendInviteDto) : Promise<ServerlessResponse<SendInviteResponse>>  {
    return this._lambdaService.lambdaPost('auth/invite', requestPayload); 
  }

  async resendInvite(requestPayload: ResendInviteDto) : Promise<ServerlessResponse<SendInviteResponse>>  {
    return this._lambdaService.lambdaPost('auth/resend', requestPayload); 
  }

  async getInviteStatus(requestPayload: InviteStatusDto): Promise<ServerlessResponse<InviteStatusResponse[]>>{
    return this._lambdaService.lambdaPost('auth/getUserStatus',requestPayload);
  }

}
